// extracted by mini-css-extract-plugin
export default {"container":"DeliveryInformation_container__PxvSO","heading":"DeliveryInformation_heading__qUdsj","controls":"DeliveryInformation_controls__+-+Wd"};